import {
    Directive,
    ElementRef,
    HostBinding,
    Input,
    OnChanges,
    Renderer2,
} from '@angular/core';

@Directive({
    selector: '[appCDNImageTransform]',
})
export class ImageSrcV2Directive implements OnChanges {
    @HostBinding('attr.src') srcAttr?: string | null;
    @HostBinding('attr.alt') altAttr?: string | null;

    @Input() src?: string | null;
    @Input() alt: string | null = null;
    @Input() includeWidth = true;
    @Input() includeHeight = true;
    @Input() enableCdn = true;

    private dpr = Math.floor(Math.max(window.devicePixelRatio || 1, 1));

    constructor(
        private el: ElementRef<HTMLElement>,
        private renderer: Renderer2
    ) {
        this.renderer.setAttribute(this.el.nativeElement, 'loading', 'lazy');
    }

    ngOnChanges(): void {
        if (!this.src) return;
        this.updateAttributes();
    }

    private updateAttributes(): void {
        const width = this.el.nativeElement.offsetWidth;
        const height = this.el.nativeElement.offsetHeight;

        requestAnimationFrame(() => {
            this.srcAttr =
                (this.includeWidth || this.includeHeight) && this.enableCdn
                    ? this.applyTransform(
                          this.src!,
                          this.includeWidth ? width : null,
                          this.includeHeight ? height : null
                      )
                    : this.src;

            this.altAttr = this.alt ?? this.getImageName(this.src!);
        });
    }

    private getImageName(src: string): string {
        const lastSlash = src.lastIndexOf('/');
        const lastQuery = src.lastIndexOf('?');
        return src.substring(
            lastSlash + 1,
            lastQuery > -1 ? lastQuery : undefined
        );
    }

    private applyTransform(
        url: string,
        width: number | null,
        height: number | null
    ): string {
        const transforms = [
            width ? `w-${width}` : '',
            height ? `h-${height}` : '',
            `dpr-${this.dpr}`,
        ].filter(Boolean);

        return `${url},${transforms.join(',')}`;
    }
}
